<template>
  <ul class="navigation" :class="{'animated': pageReady}">
    <li @click.stop.prevent="scrollTo(li.path)" v-if="li.full_path !== '/' && isShown(li) && li.parent_id === parent" v-for="(li, key) in menu" :class="{'selected' : isCurrent(li.path)}">
      <span>
        <router-link :to="`/${li.path}`" :style="`animation-delay: ${(key * 100)/1000}s`">{{ li.name }}</router-link>
      </span>
      <ul v-if="keyFinder(menu, li.object_id)">
        <li v-for="(subli, key2) in getSubLists(menu, li)" @click="setCurrentTab(subli.path)">
          <span :style="`animation-delay: ${(key2 * 70)/1000}s`">{{ subli.name }}</span>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex';
import getKeyByValue from '@/helpers/getKeyByValue';
import browserDetect from '@/helpers/browserDetect';

export default {
  name: 'navigation',
  props: ['parent'],
  data() {
    return {
      duration: 2000,
      keyFinder: getKeyByValue,
      browser: browserDetect(),
    };
  },
  computed: mapGetters({
    menu: 'navigation',
    pageReady: 'pageReady',
    menuExpanded: 'menuExpanded',
    currentPage: 'currentPage',
  }),
  mounted() {
    if (location.pathname && location.pathname !== '/') {
      const currentID = location.pathname.replace(/\//g, '');
      const waitContent = setInterval(() => {
        if (this.pageReady) {
          this.scrollTo(currentID);
          clearInterval(waitContent);
        }
      }, 100);
    }
  },
  methods: {
    disableScrollListener() {
      this.$store.commit('PAGE_IS_AUTO_SCROLLING', true);
      if (this.browser === 'ie') {
        this.$store.commit('PAGE_IS_AUTO_SCROLLING', false);
      } else {
        setTimeout(() => {
          this.$store.commit('PAGE_IS_AUTO_SCROLLING', false);
        }, this.duration - 200);
      }
    },
    scrollTo(id) {
      const element = document.getElementById(id);
      this.disableScrollListener();
      if (element) this.$SmoothScroll(element, this.duration);
      this.$store.commit('CHANGE_MENU_STATE', false);
    },
    isShown(listItem) {
      return listItem.is_published === '1' && listItem.is_show_in_menu === '1';
    },
    setCurrentTab(tabName) {
      this.$store.commit('SET_CURRENT_TAB', tabName);
      this.$store.commit('CHANGE_MENU_STATE', false);
    },
    getSubLists(menu, li) {
      const filteredMenu = menu.filter((el) => {
        const isSub = el.parent_id === li.object_id && this.isShown(el);
        return isSub;
      });
      return filteredMenu;
    },
    isCurrent(path) {
      const isCurrentItem = this.currentPage === path || this.currentPage === path.concat('-content');
      return isCurrentItem;
    },
  },
};
</script>

<style scoped>
  @keyframes menuAnimation {
    0%   {
      transform: translateY(100%);
    }
    100% { 
      transform: translateY(0);
    }
  }

  @keyframes submenuAnimation {
    0%   {
      opacity: 0;
      transform: translateX(-20px);
    }
    100% { 
      opacity: 1;
      transform: translateY(0);
    }
  }

  ul.navigation {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 0;
    margin-left: 0;
    line-height: 110%;

    li {
      position: relative;
      list-style: none;
      display: inline-block;
      vertical-align: top;
      text-transform: uppercase;
      margin: 0 20px 0 0;
      letter-spacing: 0.5px;
      font-size: 14px;
      line-height: 110%;
      outline: none;

      &:last-child {
        margin-right: 0;
      }

      &:before {
        display: none;
      }

      & > span {
        overflow: hidden;
        display: inline-block;

        a {
          transform: translateY(100%);
        }
      }

      a {
        border: none;
        position: relative;
        display: inline-block;

        &:after {
          content: '';
          width: 0;
          height: 5px;
          background: $main-color;
          position: absolute;
          left: 0;
          bottom: -1px;
          transition: width 0.5s cubic-bezier(0.455, 0.065, 0.000, 0.990);
        }

        &:hover {
          color: #fff;

          &:after {
            width: 100%;
          }
        }
      }

      &.selected {
        a:after {
          width: 100%;
        }
      }

      ul {
        position: absolute;
        pointer-events: none;
        opacity: 0;
        left: 0;
        top: 100%;
        padding: 17px 25px 15px;
        margin-left: -25px;
        background-color: rgba(47, 4, 4, 0.7);
        border-radius: 6px;
        transform: translate3d(0, 0, 0);
        transition: opacity 0.3s ease;

        li {
          display: block;
          white-space: nowrap;
          margin-bottom: 15px;

          &:last-child {
            margin-bottom: 0;
          }

          span {
            cursor: pointer;
            opacity: 0;
            transform: translateX(-20px);
            position: relative;
            display: inline-block;

            &:after {
              content: '';
              width: 0;
              height: 5px;
              background: $main-color;
              position: absolute;
              left: 0;
              bottom: -1px;
              transform: translate3d(0, 0, 0);
              transition: width 0.5s cubic-bezier(0.455, 0.065, 0.000, 0.990);
            }

            &:hover {
              color: #fff;

              &:after {
                width: 100%;
              }
            }
          }
        }
      }

      &:hover {
        ul {
          pointer-events: auto;
          opacity: 1;

          li {
            span {
              animation: submenuAnimation 0.5s cubic-bezier(0.455, 0.065, 0.000, 0.990) forwards;
            }
          }
        }
      }
    }

    &.animated {
      li {
        & > span {
          a {
            animation: menuAnimation 0.7s ease forwards;
          }
        }
      }
    }
  }

  @media (max-width: 1020px) {
    ul.navigation {
      display: block;

      li {
        position: relative;
        display: block;
        margin: 0;
        margin-bottom: 50px;

        ul {
          margin-top: 10px;
          position: relative;
          opacity: 1;
          display: block;
          background: none;

          li {
            margin-bottom: 10px;
            text-transform: none;
            font-size: 15px;

            span {
              animation: submenuAnimation 0.5s cubic-bezier(0.455, 0.065, 0.000, 0.990) forwards;
            }
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/NavigationMenu.vue?57ed8ac1